import {AbstractChartDTO} from './AbstractChartDTO';
import {InstagramPostDTO} from '../post/InstagramPostDTO';

export class InstagramPostChartDTO extends AbstractChartDTO {
  instagramPostDTO: InstagramPostDTO;
}
